import type { PanelMapping } from '../../dockviewLayoutTypes';
import type { PortfolioComponentTypes } from './portfolioManagement.components';

export type PortfolioManagementPanelType = keyof typeof PORTFOLIO_MANAGEMENT_PANELS;
export const PORTFOLIO_MANAGEMENT_PANELS = {
  trades: { id: 'trades', contentComponent: 'tradesBlotter', title: 'Trades' },
  orders: { id: 'orders', contentComponent: 'ordersBlotter', title: 'Orders' },
} satisfies PanelMapping<string, PortfolioComponentTypes>;
